import {
  collection,
  query,
  where,
  orderBy,
  getDocs,
  limit,
} from 'firebase/firestore';
import { db } from './firebase';
import { Artwork, SearchFilters, User } from '../types';

export const searchArtworks = async (filters: SearchFilters): Promise<Artwork[]> => {
  let q = query(collection(db, 'artworks'));

  // Category filter
  if (filters.category && filters.category !== 'All') {
    q = query(q, where('category', '==', filters.category));
  }

  // Price range filter
  if (filters.minPrice !== undefined) {
    q = query(q, where('price', '>=', filters.minPrice));
  }
  if (filters.maxPrice !== undefined) {
    q = query(q, where('price', '<=', filters.maxPrice));
  }

  // Sorting
  switch (filters.sortBy) {
    case 'recent':
      q = query(q, orderBy('createdAt', 'desc'));
      break;
    case 'popular':
      q = query(q, orderBy('views', 'desc'));
      break;
    case 'price-low':
      q = query(q, orderBy('price', 'asc'));
      break;
    case 'price-high':
      q = query(q, orderBy('price', 'desc'));
      break;
  }

  q = query(q, limit(50));

  const querySnapshot = await getDocs(q);
  let artworks = querySnapshot.docs.map(doc => {
    const data = doc.data() as Partial<Artwork> & { createdAt?: any };
    const createdAt = data.createdAt?.toDate ? data.createdAt.toDate() : (data.createdAt || new Date());
    return ({
      id: doc.id,
      ...data,
      createdAt,
    } as Artwork);
  });

  // Text search (client-side)
  if (filters.query) {
    const searchLower = filters.query.toLowerCase();
    artworks = artworks.filter(artwork =>
      artwork.title.toLowerCase().includes(searchLower) ||
      artwork.artistName.toLowerCase().includes(searchLower) ||
      artwork.description?.toLowerCase().includes(searchLower)
    );
  }

  return artworks;
};

export const searchArtists = async (searchQuery: string): Promise<User[]> => {
  const usersRef = collection(db, 'users');
  const querySnapshot = await getDocs(usersRef);

  const searchLower = searchQuery.toLowerCase();
  const users = querySnapshot.docs
    .map(doc => {
      const data = doc.data() as Partial<User>;
      return ({ id: doc.id, ...data } as User);
    })
    .filter(user =>
      user.name?.toLowerCase().includes(searchLower) ||
      user.email?.toLowerCase().includes(searchLower)
    );

  return users;
};